/**
 * Bun redesign preview gate (docs/BUN_REDESIGN_PLAN.md).
 *
 * One runtime flag decides whether the app serves the Bun versions of the
 * migrated screens or the legacy ones. Bun is the default for clients and
 * advisors; the existing per-browser overrides remain available:
 *
 *   any URL with ?bun=on   -> Bun screens (sticky via localStorage)
 *   any URL with ?bun=off  -> back to legacy
 *
 * REACT_APP_BUN_PREVIEW=false explicitly restores the legacy build-time
 * default without overriding URL or saved preferences. The flag is read once
 * at module load: every gate sits at a lazy-import seam, so a full page load always
 * re-evaluates it and the unused side of each seam stays out of the loaded
 * bundle.
 */
const STORAGE_KEY = "bun-preview";

const readFlag = () => {
  try {
    const param = new URLSearchParams(window.location.search).get("bun");
    if (param === "on" || param === "off") {
      // Persisting is best effort: a blocked storage write must not discard
      // the URL param that was already read successfully.
      try {
        localStorage.setItem(STORAGE_KEY, param);
      } catch (e) {
        // Ignore: the param still applies for this page load.
      }
      return param === "on";
    }
    const stored = localStorage.getItem(STORAGE_KEY);
    if (stored === "on" || stored === "off") return stored === "on";
  } catch (e) {
    // URL or storage access blocked (sandboxed embed, blocked site data):
    // fall through to the build-time default.
  }
  return process.env.REACT_APP_BUN_PREVIEW !== "false";
};

export const BUN_PREVIEW = readFlag();
